function formatDatePart(value: number): string {
  return String(value).padStart(2, '0')
}

export function formatDateInputValue(date: Date): string {
  return `${date.getFullYear()}-${formatDatePart(date.getMonth() + 1)}-${formatDatePart(date.getDate())}`
}

export function buildDefaultMetaDateRange(): { dateFrom: string; dateTo: string } {
  const end = new Date()
  const start = new Date()
  start.setDate(end.getDate() - 29)

  return {
    dateFrom: formatDateInputValue(start),
    dateTo: formatDateInputValue(end),
  }
}
